import React, { useEffect, useState } from "react";
import logo from '../../../assets/msw-logo.png';
import axios from "../../../api/axios";
import { useQuery } from "@tanstack/react-query";

const Disapproved = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');

    const [message, setMessage] = useState(null);

    const { data: disapprovedTimesheet, isLoading, error } = useQuery({
        queryKey: ['timesheetDisapproval'],
        queryFn: async () => {
            const res = await axios.patch('dtr/timesheets', { status: 2 }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        enabled: !!token,
        staleTime: Infinity,
        retry: false
    });

    useEffect(() => {
        if (error) {
            setMessage(error.response?.data.response || 'Something went wrong while disapproving submitted DTR!');
        } else if (disapprovedTimesheet) {
            setMessage(disapprovedTimesheet);
        }
    }, [error, disapprovedTimesheet]);

    return (
        <div className="approval-disapproval disapproved">
            <div className='icon'>
                <i className={`fa ${isLoading ? 'fa-spinner fa-spin' : 'fa-check-circle'}`}></i>
            </div>
            <p className='message'>
                {isLoading ? 'Loading...' : message}
            </p>
            <div className='ad-footer'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <p>&copy; Megasportsworld 2025.</p>
            </div>
        </div>
    );
};

export default Disapproved;
